import { useParams, Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { articles, categories } from '@/mocks/articles';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ContentCard from '@/components/feature/ContentCard';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const [activeSlug, setActiveSlug] = useState(slug || 'movie');

  useEffect(() => {
    if (slug) setActiveSlug(slug);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [slug]);

  const currentCategory = categories.find((c) => c.slug === activeSlug);
  const filteredArticles = articles.filter((a) => a.categorySlug === activeSlug);

  const seoJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${currentCategory?.name || '分类'} - 香蕉影视`,
    description: `香蕉影视${currentCategory?.name || '影视'}分类，海量${currentCategory?.name || '影视'}资源免费在线观看。`,
    url: `https://www.xiangjiaoys.com/category/${activeSlug}`,
    isPartOf: {
      '@type': 'WebSite',
      name: '香蕉影视',
      url: 'https://www.xiangjiaoys.com/',
    },
  };

  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: currentCategory?.name || '分类' },
  ];

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(seoJsonLd) }} />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <div className="bg-background-100 border-b border-background-200/70">
            <Breadcrumb items={breadcrumbItems} />
            <div className="w-full px-4 md:px-6 pb-6">
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
                {currentCategory?.name}
              </h1>
              <div className="flex flex-wrap gap-2">
                {categories.map((cat) => {
                  const isActive = cat.slug === activeSlug;
                  return (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      onClick={() => setActiveSlug(cat.slug)}
                      className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                        isActive
                          ? 'bg-primary-500 text-background-50'
                          : 'bg-background-50 text-foreground-600 hover:bg-background-200'
                      }`}
                    >
                      <i className={`${cat.icon} mr-1.5`}></i>
                      {cat.name}
                    </Link>
                  );
                })}
              </div>
            </div>
          </div>

          <section className="w-full px-4 md:px-6 py-8 md:py-12">
            {filteredArticles.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-6">
                {filteredArticles.map((article) => (
                  <ContentCard key={article.id} article={article} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                  <i className="ri-emotion-sad-line text-4xl text-foreground-400"></i>
                </div>
                <p className="text-foreground-500 text-sm">该分类暂无内容，敬请期待</p>
                <Link
                  to="/"
                  className="inline-block mt-4 text-sm text-primary-500 hover:text-primary-600 cursor-pointer transition-colors"
                >
                  返回首页
                </Link>
              </div>
            )}
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}